<template>
  <article class="layout-section -align-side">
    <figure class="layout-section__figure" :style="{ backgroundImage }" />

    <section class="layout-section__content">
      <h2 class="layout-section__title">{{ wp.members.title }}</h2>
      <p>
        {{ wp.members.text }}
      </p>

      <RouterLink :to="{ name: 'about-members' }" class="button layout-section__cta">
        Explorez nos membres
        <SvgIcon id="action-arrow" />
      </RouterLink>
    </section>
  </article>
</template>

<script>
export default {
  name: 'RegisterMore',
  inject: ['wp'],
  computed: {
    backgroundImage() {
      return `url(${this.wp.members.image})`
    }
  }
}
</script>
